<template>
  <PageContainer>
    <template v-slot:body>
      <div
        :class="$style.wrapper"
      >
        <GettingStartedPanel
          v-if="showGettingStarted"
          :buttonLabel="buttonCta.text"
          :class="$style.gettingStartedContainer"
          data-test-id="CloudInsightsMainPanel__GettingStartedPanel"
          :itemType="itemType"
          :showLearnMoreExternalIcon="true"
          :visible="!accountsTotalCount"
          @ctaButtonClick="handleGettingStartedCtaClick"
        />
        <CloudInsightsItemList
          v-else
          :class="$style.itemList"
          data-test-id="CloudInsightsMainPanel__ItemList"
          :mainLoading="loading"
        />
        <AddAccountModal
          :showModal="showModal"
          @activate="hideModal"
          @cancel="hideModal"
        />
      </div>
    </template>
  </PageContainer>
</template>

<script>
import {
  ItemTypeConsts,
  StoreModuleMap,
} from 'client/util/Constants';
import { PageContainer } from '@jumpcloud/ui-components';
import { mapActions, mapGetters } from 'vuex';
import AddAccountModal from 'client/CloudInsights/components/AddAccountModal.vue';
import CloudInsightsItemList from 'client/CloudInsights/CloudInsightsItemList/CloudInsightsItemList.vue';
import GettingStartedPanel from 'client/components/GettingStartedPanel/GettingStartedPanel.vue';

const cloudInsightsAccountsModule = StoreModuleMap[ItemTypeConsts.cloudInsightsAccounts];

export default {
  name: 'CloudInsightsMainPanel',

  components: {
    AddAccountModal,
    CloudInsightsItemList,
    GettingStartedPanel,
    PageContainer,
  },

  data() {
    return {
      buttonCta: {
        text: 'Add An Account',
      },
      itemType: ItemTypeConsts.cloudInsights,
      loading: false,
      showModal: false,
    };
  },

  computed: {
    ...mapGetters(cloudInsightsAccountsModule, {
      accountsTotalCount: 'getTotalCount',
    }),

    showGettingStarted() {
      return !this.accountsTotalCount && !this.loading;
    },
  },

  async created() {
    this.loadAccounts();
  },

  methods: {
    ...mapActions(cloudInsightsAccountsModule, {
      fetchAccounts: 'fetchCollection',
    }),

    handleGettingStartedCtaClick() {
      this.showModal = true;
    },

    hideModal() {
      this.showModal = false;
    },

    async loadAccounts() {
      this.loading = true;
      await this.fetchAccounts();
      this.loading = false;
    },
  },
};
</script>

<style module scoped>
.Grid {
  margin-bottom: 2rem;
}

.gettingStartedContainer {
  height: 100%;
  padding-bottom: 20px;
}

.wrapper {
  height: 100%;
}
</style>
